import { LegalLayout, LegalSection } from "@/components/uc/LegalLayout";
import { ShieldCheck, Lock, Landmark, KeyRound } from "lucide-react";

const PILLARS = [
  [ShieldCheck, "SOC 2-Compliant Infrastructure", "The Command OS runs on cloud infrastructure operated under SOC 2 Type II attested controls — continuous monitoring, least-privilege access, audited change management, and encrypted transport (TLS 1.2+) on every connection."],
  [Landmark, "ISO 20022-Compliant Financial Processing", "Financial flows are processed through Stripe's payment rails, which interoperate with the ISO 20022 financial messaging standard adopted by modern banking networks — structured, auditable, machine-readable transaction data end to end."],
  [Lock, "Encryption Everywhere", "Vault documents are sealed with Fernet symmetric encryption (AES-128-CBC + HMAC). Passwords are bcrypt-hashed. Gmail app passwords are encrypted at rest. Sessions ride httpOnly secure cookies — never browser storage."],
  [KeyRound, "Execution Guardrails", "Code runs in isolated sandboxes with CPU/memory caps. Browser automation is read-only and SSRF-guarded against private networks. Every executed action archives an encrypted, signed record — a permanent audit trail."],
];

export default function Security() {
  return (
    <LegalLayout eyebrow="SECURITY STATEMENT" title="Security" testId="security-page">
      <p>Sovereignty demands custody. Here is how THE SOVEREIGN UMBRELLA COMMAND protects your empire.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="security-pillars">
        {PILLARS.map(([Icon, title, body]) => (
          <div key={title} className="border border-white/10 bg-white/[0.02] p-5">
            <Icon size={18} className="text-emerald-400 mb-3"/>
            <h2 className="font-serif-display text-lg text-white mb-2">{title}</h2>
            <p className="text-white/60 text-sm leading-relaxed">{body}</p>
          </div>
        ))}
      </div>
      <LegalSection heading="Additional Controls">
        <ul className="list-disc pl-5 space-y-2 text-white/60">
          <li>Strict multi-tenant isolation — every query is scoped to your account ID at the database layer.</li>
          <li>Financial double-gate: no charge fires without a stored payment method AND your explicit per-transaction approval.</li>
          <li>Dead Man's Switch: configurable inactivity failsafe that alerts your designated beneficiary.</li>
          <li>Live Stripe keys are verified against Stripe before activation and stored in secured configuration — never in client code.</li>
          <li>Vault key rotation is supported and logged.</li>
        </ul>
      </LegalSection>
      <LegalSection heading="Disclosure">
        <p>Found a vulnerability? Report it to <span className="text-amber-400">security@umbrellacommand.example</span>. We acknowledge within 48 hours and do not pursue good-faith researchers.</p>
      </LegalSection>
    </LegalLayout>
  );
}
